import {defineStore} from 'pinia'
import axios from "axios";
import {ITrap} from "@/types/trap";
import {trapsListUrl} from "@/services/api";

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useTrapsStore = defineStore('traps', {
    state: () => ({
        loading: false as boolean,
        traps: [] as ITrap[],
    }),
    persist: true,
    getters: {
        getTrapById: (state) => (id: number) => state.traps.find(trap => id === trap.id),
        getTrapsByIds: (state) => (ids: number[]) => state.traps.filter(trap => ids.includes(trap.id)),
        search: (state) => async (search: string) => state.traps.filter(trap => {
            const lowerSearch = search.toLowerCase();
            return trap.device_type.toLowerCase().includes(lowerSearch) ||
                trap.characteristic.toLowerCase().includes(lowerSearch) ||
                trap.active_substance.toLowerCase().includes(lowerSearch);
        }),
    },
    actions: {
        async loadTraps() {
            this.loading = true;
            const response = await axios.get(trapsListUrl)
            if (response.status === 200) {
                this.traps = response.data;
            }
            this.loading = false;
            return response;
        },
    }
});
